import Vue from 'vue'
import Router from 'vue-router'
import login from '@/pages/Login'
import FlowList from '@/pages/attenceflow/FlowList'
import FlowDetail from '@/pages/attenceflow/FlowDetail'
import FlowApprove from '@/pages/attenceflow/FlowApprove'
import FlowComment from '@/pages/attenceflow/FlowComment'
import AttenceHome from '@/pages/attenceflow/AttenceHome'
import UserInfo from '@/pages/attenceflow/UserInfo'
import PasswordUpdate from '@/pages/attenceflow/PasswordUpdate'
import LeaveList from '@/pages/attenceflow/leave/list'
import LeaveForm from '@/pages/attenceflow/leave/form'
import LeaveAudit from '@/pages/attenceflow/leave/audit'
import LeaveDetail from '@/pages/attenceflow/leave/detail'
import OverTimeList from '@/pages/attenceflow/workovertime/list'
import OverTimeForm from '@/pages/attenceflow/workovertime/form'
import OverTimeAudit from '@/pages/attenceflow/workovertime/audit'
import AttenceErrList from '@/pages/attenceflow/userAttenceErrAppeal/list'
import AttenceErrForm from '@/pages/attenceflow/userAttenceErrAppeal/form'
import AttenceErrAudit from '@/pages/attenceflow/userAttenceErrAppeal/audit'
import UserOutCityList from '@/pages/attenceflow/userOutCity/list'
import UserOutCityForm from '@/pages/attenceflow/userOutCity/form'
import UserOutCityAudit from '@/pages/attenceflow/userOutCity/audit'
import AwayList from '@/pages/attenceflow/away/list'
import AwayForm from '@/pages/attenceflow/away/form'
import AwayAudit from '@/pages/attenceflow/away/audit'
import QueryList from '@/pages/attenceflow/query/list'
import LbsAttendanceList from '@/pages/attenceflow/lbsAttendance/list'
import LbsAttendanceForm from '@/pages/attenceflow/lbsAttendance/form'
import LbsAttendanceAudit from '@/pages/attenceflow/lbsAttendance/audit'
import HolidayCancelList from '@/pages/attenceflow/holidayCancel/list'
import HolidayCancelForm from '@/pages/attenceflow/holidayCancel/form'
import HolidayCancelAudit from '@/pages/attenceflow/holidayCancel/audit'
import NoticeList from '@/pages/attenceflow/notice/list'
import Error from '@/pages/attenceflow/Error'
import AwayCancelList from '@/pages/attenceflow/awayCancel/list'
import AwayCancelForm from '@/pages/attenceflow/awayCancel/form'
import AwayCancelAudit from '@/pages/attenceflow/awayCancel/audit'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
    },
    {
      path: '/attenceflow/FlowList',
      name: 'FlowList',
      component: FlowList,
    },
    {
      path: '/attenceflow/FlowDetail',
      name: 'FlowDetail',
      component: FlowDetail,
    },
    {
      path: '/attenceflow/FlowApprove',
      name: 'FlowApprove',
      component: FlowApprove,
    },
    {
      path: '/attenceflow/FlowComment',
      name: 'FlowComment',
      component: FlowComment,
    },
    {
      path: '/attenceflow/AttenceHome',
      name: 'AttenceHome',
      component: AttenceHome,
    },
    {
      path: '/attenceflow/UserInfo',
      name: 'UserInfo',
      component: UserInfo,
    },
    {
      path: '/attenceflow/PasswordUpdate',
      name: 'PasswordUpdate',
      component: PasswordUpdate,
    },
    {
      path: '/attenceflow/leave/list',
      name: 'LeaveList',
      component: LeaveList,
    },
    {
      path: '/attenceflow/leave/form',
      name: 'LeaveForm',
      component: LeaveForm,
    },
    {
      path: '/attenceflow/leave/audit',
      name: 'LeaveAudit',
      component: LeaveAudit,
    },
    {
      path: '/attenceflow/leave/detail',
      name: 'LeaveDetail',
      component: LeaveDetail,
    },
    {
      path: '/attenceflow/workovertime/list',
      name: 'OverTimeList',
      component: OverTimeList,
    },
    {
      path: '/attenceflow/workovertime/form',
      name: 'OverTimeForm',
      component: OverTimeForm,
    },
    {
      path: '/attenceflow/workovertime/audit',
      name: 'OverTimeAudit',
      component: OverTimeAudit,
    },
    {
      path: '/attenceflow/userAttenceErrAppeal/list',
      name: 'AttenceErrList',
      component: AttenceErrList,
    },
    {
      path: '/attenceflow/userAttenceErrAppeal/form',
      name: 'AttenceErrForm',
      component: AttenceErrForm,
    },
    {
      path: '/attenceflow/userAttenceErrAppeal/audit',
      name: 'AttenceErrAudit',
      component: AttenceErrAudit,
    },
    {
      path: '/attenceflow/userOutCity/list',
      name: 'UserOutCityList',
      component: UserOutCityList,
    },
    {
      path: '/attenceflow/userOutCity/form',
      name: 'UserOutCityForm',
      component: UserOutCityForm,
    },
    {
      path: '/attenceflow/userOutCity/audit',
      name: 'UserOutCityAudit',
      component: UserOutCityAudit,
    },
    {
      path: '/attenceflow/away/list',
      name: 'AwayList',
      component: AwayList,
    },
    {
      path: '/attenceflow/away/form',
      name: 'AwayForm',
      component: AwayForm,
    },
    {
      path: '/attenceflow/away/audit',
      name: 'AwayAudit',
      component: AwayAudit,
    },
    {
      path: '/attenceflow/query/list',
      name: 'QueryList',
      component: QueryList,
    },
    {
      path: '/attenceflow/lbsAttendance/list',
      name: 'LbsAttendanceList',
      component: LbsAttendanceList,
    },
    {
      path: '/attenceflow/lbsAttendance/form',
      name: 'LbsAttendanceForm',
      component: LbsAttendanceForm,
    },
    {
      path: '/attenceflow/lbsAttendance/audit',
      name: 'LbsAttendanceAudit',
      component: LbsAttendanceAudit,
    },
    {
      path: '/attenceflow/holidayCancel/list',
      name: 'HolidayCancelList',
      component: HolidayCancelList,
    },
    {
      path: '/attenceflow/holidayCancel/form',
      name: 'HolidayCancelForm',
      component: HolidayCancelForm,
    },
    {
      path: '/attenceflow/holidayCancel/audit',
      name: 'HolidayCancelAudit',
      component: HolidayCancelAudit,
    },
    {
      path: '/attenceflow/notice/list',
      name: 'NoticeList',
      component: NoticeList,
    },
    {
      path: '/attenceflow/Error',
      name: 'Error',
      component: Error,
    },
    {
      path: '/attenceflow/awayCancel/list',
      name: 'AwayCancelList',
      component: AwayCancelList,
    },
    {
      path: '/attenceflow/awayCancel/form',
      name: 'AwayCancelForm',
      component: AwayCancelForm,
    },
    {
      path: '/attenceflow/awayCancel/audit',
      name: 'AwayCancelAudit',
      component: AwayCancelAudit,
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js